import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { useNavigate } from "react-router-dom";
import {
  getStatusColor,
  getStatusText,
} from "../../Common/Utils/statusUtils";
import "../../Common/Styles/Listing.css";
import search from "../../assets/images/search-lg.svg";
import CardHeader from "../../Common/CardHeader/CardHeader";
import ModalDelete from "../../Common/Popup/ModalDelete";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { deleteOnePartnerMembershipData, getPartnershipListData } from "../../../redux/driverManagement/action";
import DeletePartner from "./DeletePartner";

const PartnerList = () => {
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
  });
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [loading, setLoading] = useState(false);
  const getpartnerList = useSelector((state) => state?.bookingSlice?.getpartnerList);
  console.log(getpartnerList, "getpartnerList")


  const dispatch = useDispatch();
  const navigate = useNavigate();



  useEffect(() => {
    dispatch(getPartnershipListData(params));
  }, [params, dispatch]);



  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteOnePartnerMembershipData(currentComponent.id, setLoading, params));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const addComponent = () => {
    navigate("/addpartner");
  };

  const updateComponent = (id) => {
    navigate(`/updatepartner/${id}`);
  };

  return (
    <div className="card-head">
      <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? "overlay show" : "overlay"}
      ></div>
      <CardHeader
        params={params}
        setParams={setParams}
        addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
      />
      <CardBody className="table-sec px-3">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Company Name</th>
              <th scope="col">CR Number</th>
              <th scope="col"> Status</th>
              <th scope="col" className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {getpartnerList?.driver_partners?.length > 0 ? (
              getpartnerList?.driver_partners?.map((item, index) => (
                <tr key={item.id}>
                  <td> {index + 1 + (params?.page - 1) * 10}</td>
                  <td>{item?.company_name}</td>
                  <td>{item?.cr_number}</td>
                  <td>
                    <span style={{ color: getStatusColor(item?.status) }}>
                      {getStatusText(item?.status)}
                    </span>
                  </td>
                  <td>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ columnGap: "10px" }}
                    >
                      <button
                        className="border-button"
                        onClick={() => updateComponent(item.id)}
                      >
                        <span>Update</span>
                      </button>
                      <button
                        className="background-button"
                        onClick={() => {
                          setModal(true);
                          setCurrentComponent(item);
                        }}
                      >
                        <span>Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No partner found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <CommonPagination
          params={params}
          setParams={setParams}
          pagination_meta={getpartnerList?.pagination_meta}
        />
      </CardBody>
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <DeletePartner
          itemType="Partner"
          modalTitle="Partner"
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </div>
  );
};

export default PartnerList;
